/** InsCoder WANG.J 2026-07-15 B + Register product specification section **/
if (!customElements.get("cust-specification")) {
  customElements.define("cust-specification", class extends HTMLElement {});
}
/** InsCoder WANG.J 2026-07-15 E + Register product specification section **/
